<div style="display:block;padding-top:10px;">
<app-data-table [columns]="tableColumns" [value]="trainingHistories"
                [disableSearch]="true" [rightCaptionTemplate]="rightCaption" sortField="startOn">
  <ng-template #rightCaption>
    <button pButton type="button" class="action-secondary" icon="fa fa-plus"
            label="Training History" pTooltip="Make New Training History"
            tooltipPosition="top"
            (click)="onClickAddRow()">
    </button>
  </ng-template>

  <ng-template #actionTemplate let-row="row">
    <button pButton type="button" class="icon-action" icon="fa fa-pencil"
            pTooltip="Update" tooltipPosition="top"
            (click)="onClickEditRow(row)">
    </button>
    <button pButton type="button" class="icon-negative" icon="fa fa-trash"
            pTooltip="Delete" tooltipPosition="top"
            (click)="onClickDeleteRow(row)">
    </button>
  </ng-template>
</app-data-table>
</div>

<div class="p-grid" style="margin-top:10px;text-align:right;">
  <div class="p-col-12">
    <button pButton type="button" class="button-action" icon="fa fa-check"
            label="Save"
            (click)="onClickSaveTrainingHistory()"></button>
  </div>
</div>

<p-confirmDialog></p-confirmDialog>

<!-- dialog for new Training History or editing an existing Training History -->
<p-dialog *ngIf="trainingHistoryToEdit&&displayDialog" [(visible)]="displayDialog" header="Training History"
          [dismissableMask]="true" [responsive]="true"
          [modal]="true" [resizable]="false" [style]="PrimeNgConfig.DialogStyle40">
  <form #dialogForm="ngForm">
    <div class="p-grid">

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Description*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <input pInputText name="description" type="text"
               [style]="{ 'overflow': 'visible', 'width': '100%'}"
               [(ngModel)]="trainingHistoryToEdit.description" required
               [maxLength]="Validation.AddrMaxLength"/>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label for="billable">Billable*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-dropdown id="billable" name="billable"
                    [placeholder]="PrimeNgConfig.DropdownPlaceholder" [style]="{ 'overflow': 'visible', 'width': '100%'}" [options]="billableDropDown"
                    [(ngModel)]="trainingHistoryToEdit.billable"
                    required></p-dropdown>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Training StartOn*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="startOn" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxEndOn" icon="fa fa-calendar"
                    showIcon="true" [(ngModel)]="trainingHistoryToEdit.startOn" required [monthNavigator]="true" readonlyInput="true"></p-calendar>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label>Training EndOn*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <p-calendar name="trainingEndOn" dataType="string" [dateFormat]="Format.PcalendarDate" [maxDate]="maxEndOn" icon="fa fa-calendar"
                    showIcon="true" [(ngModel)]="trainingHistoryToEdit.endOn" required [monthNavigator]="true" readonlyInput="true"></p-calendar>
      </div>

      <div class="p-col-12 p-md-4 p-lg-4">
        <label for="cost">Cost*</label>
      </div>
      <div class="p-col-12 p-md-8 p-lg-8">
        <input pInputText id="cost" name="cost" type="text" [(ngModel)]="trainingHistoryToEdit.cost" required/>
      </div>
    </div>
  </form>

  <p-footer>
    <div>
      <button pButton type="button" class="button-inaction" icon="fa fa-close" label="Cancel"
              (click)="displayDialog=false"></button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Add"
              (click)="onClickSaveRow(trainingHistoryToEdit)" [disabled]="!dialogForm.form.valid"></button>
    </div>
  </p-footer>
</p-dialog>
